module.exports = __webpack_public_path__ + "static/media/forbidden.9c2876c9.svg";